import {useState} from "react";

export type UseLoadingReturnType = [boolean, () => void, () => void];

export const useLoading = (): UseLoadingReturnType => {
    const [loading, setLoading] = useState<boolean>(false);
    return [
        loading,
        () => setLoading(true),
        () => setLoading(false)
    ];
}